import React, { useState, useContext, Fragment } from 'react';
import { orderStatusArray, actionList } from '../../../../../config';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import CustomSkeleton from '../../../../../components/OtherElements/CustomSkeleton';
import { useHistory, useParams } from 'react-router-dom';
import red from '@material-ui/core/colors/red';
import Typography from '@material-ui/core/Typography';
import { __ } from '../../../../../utils/i18n';
import axios from '../../../../../api/axios';
import { useQuery } from 'react-query';
import useToast from 'hooks/useToast';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  map: {
    height: 400,
    border: `1px solid ${theme.palette.primary.light}`,
    marginTop: theme.spacing(1),
    position: 'relative',
  },
  orderStatus: {
    color: red[500],
    textAlign: 'center',
  },
}));

const EditAction = ({ refresh, freightId, data }) => {
  const classes = useStyles();
  const history = useHistory();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [actionSelected, setActionSelected] = useState(null);
  const { orderId } = useParams();
  const statusArray = [
    { name: 'pending', value: 'درحال بررسی' },
    { name: 'inProgress', value: 'جاری' },
    { name: 'delivered', value: 'تکمیل شده' },
    { name: 'canceled', value: 'کنسل شده' },
  ];

  const handleSelectAction = (e) => {
    const { value } = e.target;
    setActionSelected(value);
  };
  const handleTakeAction = async () => {
    if (actionSelected) {
      // if (['inProgress', 'pending', 'canceled']?.includes(actionSelected)) {
      try {
        setLoading(true);
        const { data } = await axios.put(
          `/api/v1/admin/freight/orders/${orderId}/status`,
          {
            orderId,
            status: actionSelected,
          }
        );
        if (data?.ok) toast.success('تغییرات با موفقیت انجام شد.');
        refresh();
        setActionSelected(null);
      } catch (error) {
        toast.error(error);
      } finally {
        setLoading(false);
      }
      //   return;
      // }
      // history.push(`/protected/admin/freights/freightOrders/${freightId}`);
    } else {
      toast.success('یک وضعیت را انتخاب کنید', 2);
    }
  };

  return (
    <Fragment>
      {data ? (
        <Fragment>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <Typography
                variant="h1"
                component="div"
                className={classes.orderStatus}
              >
                {
                  statusArray.find((status) => status.name === data.status)
                    .value
                }
              </Typography>
            </Grid>
            <Grid item>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>تغییر وضعیت سفارش</InputLabel>
                <Select
                  value={actionSelected ? actionSelected : ''}
                  onChange={handleSelectAction}
                >
                  {statusArray?.map((item) => (
                    <MenuItem key={item.name} value={item.name}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                size="medium"
                endIcon={loading ? <CircularProgress size={10} /> : null}
                disabled={!actionSelected || loading}
                onClick={handleTakeAction}
              >
                اعمال
              </Button>
            </Grid>
          </Grid>
          {/* <div className={classes.map}>
            <Map order={order} />
          </div> */}
        </Fragment>
      ) : (
        <CustomSkeleton count={2} height={38} />
      )}
    </Fragment>
  );
};

export default EditAction;
